<template>
    <div>
        <!-- <el-button style="float: right;margin-right: 5px;" v-if="this.applyStatus == 2 || this.applyStatus == '' || this.applyStatus == 0 || this.applyStatus == null"
                   type="primary" size='mini' @click="beforeUploadForm1()">上传文件
        </el-button> -->
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'5'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <!-- <el-button @click="checkDialogVisible = false">取 消</el-button> -->
            <el-button icon="el-icon-upload2" size='mini' type="success">其它</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'6'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <!-- <el-button @click="checkDialogVisible = false">取 消</el-button> -->
            <el-button icon="el-icon-upload2" size='mini' type="success"><span style="color: red;">*</span>主要设备清单</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'3'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <!-- <el-button @click="checkDialogVisible = false">取 消</el-button> -->
            <el-button icon="el-icon-upload2" size='mini' type="success">3C认证/自我声明</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'7'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <el-button icon="el-icon-upload2" size='mini' type="success">16949体系证书</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'8'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <el-button icon="el-icon-upload2" size='mini' type="success">9000体系证书</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'9'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <el-button icon="el-icon-upload2" size='mini' type="success">14001体系证书</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'10'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <el-button icon="el-icon-upload2" size='mini' type="success">45001体系证书</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'11'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <el-button icon="el-icon-upload2" size='mini' type="success">信息安全体系证书</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'12'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <el-button icon="el-icon-upload2" size='mini' type="success">付款信息附件</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'1'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <!-- <el-button @click="checkDialogVisible = false">取 消</el-button> -->
            <el-button icon="el-icon-upload2" size='mini' type="success"><span style="color: red;">*</span>营业执照</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'2'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <!-- <el-button @click="checkDialogVisible = false">取 消</el-button> -->
            <el-button icon="el-icon-upload2" size='mini' type="success"><span style="color: red;">*</span>体系认证</el-button>
        </el-upload>
        <el-upload style="float: right;margin-right: 10px;"
                class="upload-demo"
                action
                :http-request="upload"
                :show-file-list="false"
                :with-credentials='true'
                :data="'4'"
                :file-list="fileList"
                :on-success="successHandle"
                :before-upload="beforeUploadValidate"
                :multiple="true"
                accept=".pdf,.jpg,.jpeg,.png"
        >
            <!-- <el-button @click="checkDialogVisible = false">取 消</el-button> -->
            <el-button icon="el-icon-upload2" size='mini' type="success"><span style="color: red;">*</span>公司简介</el-button>
        </el-upload>
        <h3>附件列表</h3>
        <el-table size="small" :data="dataList">
            <!-- <el-table-column type="selection" fixed="left"></el-table-column> -->
            <el-table-column label="序号" header-align="center" width="90" align="center">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="bizSubTypeName" label="类型" align="center" header-align="center"></el-table-column>
            <el-table-column prop="originalName" label="文件名称" align="center" header-align="center">
                <template slot-scope="scope">
                    <el-link :underline="false" type="primary" @click="uploadConfig(scope.row)">
                        {{scope.row.originalName}}
                    </el-link>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="fileDesc" label="描述" align="center" header-align="center"></el-table-column> -->
            <el-table-column header-align="center" align="center" label="操作">
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改描述</el-button> -->
                    <el-button :disabled="scope.row.fileType != 'image/png' && scope.row.fileType != 'image/jpg' &&  scope.row.fileType != 'application/pdf'" type="text" size="small" @click="viewHandle(scope.row)">预览</el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="附件描述" width="30%" :append-to-body="true" :visible.sync="updateVisible" @close='closeDialog'>
            <el-form label-width="0px" :model="dataForm" ref="dataForm">
                <el-form-item prop="sysFileDescribe">
                    <el-input type="textarea" :rows="2" v-model="dataForm.sysFileDescribe"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveRemark()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="checkDialogVisible" title="文件描述">
            <el-form>
                <el-select v-model="ruleForm.sysFileType">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <br><br>
                <div>
                    <div align="right">
                        <el-upload class="upload-demo"
                                   action
                                   :http-request="upload"
                                   :show-file-list="false"
                                   :with-credentials='true'
                                   :data="ruleForm"
                                   :file-list="fileList"
                                   :on-success="successHandle"
                                   :before-upload="beforeUploadForm"
                        >
                            <!-- <el-button @click="checkDialogVisible = false">取 消</el-button> -->
                            <el-button type="success">确认上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="上传中，请耐心等待！" :modal='true' :center='true' :visible.sync="uploadLoading"
            :modal-append-to-body='false' :append-to-body='false' width='400px'
            :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
        </el-dialog>
        <view-image-or-pdf v-if="viewVisible" ref="viewImageOrPdf"></view-image-or-pdf>
        <pdf-view v-if="pdfVisible" ref="pdfView"></pdf-view>
    </div>
</template>

<script>
    import { uploadBasicInfo, listInvitedForSupplier, getBasicInfoFiles} from '@/controller/portal'
    import {getUrl,deleteFileById} from '@/controller/sys'
    import ViewImageOrPdf from '@/components/image-view/index'
    import PdfView from '@/components/pdf-view/index'
    export default {
        data() {
            return {
                fileList: [],
                dataListSelections: [],
                sysFileDocumentname: '',
                sysFileUploader: '',
                sysFileUploadTime: '',
                sysFileDescribe: '',
                venderbaseinfoId: '',
                venderInviteFid: '',
                uploadFlag: false,
                //applyStatus: 0,
                ruleForm: {
                    venderInviteFid: '',
                    sysFileType: ''
                },
                dataList: [],
                formMaxSize: 20, // 上传文件大小
                updateVisible: false,
                dataForm: {
                    sysFileDescribe: ''
                },
                sysFileId: '',
                pdfVisible: false,
                checkDialogVisible: false,
                viewVisible:false,
                uploadLoading:false,
                options: [
                    {label: '营业执照', value: '1'},
                    {label: '体系认证', value: '2'},
                    {label: '3C认证/自我声明', value: '3'},
                    {label: '公司简介', value: '4'},
                    {label: '主要设备清单', value: '6'},
                    {label: '其它', value: '5'},
                    {label: '16949体系证书', value: '7'},
                    {label: '9000体系证书', value: '8'},
                    {label: '14001体系证书', value: '9'},
                    {label: '45001体系证书', value: '10'},
                    {label: '信息安全体系证书', value: '11'},
                    {label: '付款信息附件', value: '12'},
                ]
            }
        },
        components: {
            ViewImageOrPdf,
            PdfView
        },
        mounted() {
            this.getList()
        },
        watch: {
            venderInviteFid() {
                this.getDataList()
            }
        },
        props:{
          applyStatus: String,
        },
        methods: {
            upload(obj) {
                var subFileType = obj.data
                let formData = new FormData()
                formData.set('file', obj.file)
                formData.set('inviteId', this.venderInviteFid)
                //formData.set('subFileType', this.ruleForm.sysFileType)
                formData.set('subFileType', subFileType)
                this.uploadLoading = true;
                uploadBasicInfo(formData).then(data => {
                    if(data.code === '00'){
                        this.$message.success({
                            message: '上传成功！',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                        this.uploadLoading = false;
                        this.getDataList()
                    }
                    this.uploadLoading = false;
                })
            },
            viewHandle(row) {
                if(row.fileType == 'application/pdf') {
                    this.pdfVisible = true
                    this.$nextTick(() => {
                        this.$refs.pdfView.init(row.fileUrl, row.originalName);
                    })
                } else {
                    this.viewVisible = true
                    this.$nextTick(() => {
                        this.$refs.viewImageOrPdf.init(row.fileUrl, row.originalName)
                    })
                } 

            },
            // 上传前验证文件格式和大小
            beforeUploadValidate(file) {
                const allowedTypes = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png']
                const maxSize = 2 * 1024 * 1024 // 2MB
                if (!allowedTypes.includes(file.type)) {
                    this.$message.error('只支持上传 PDF/JPG/PNG 格式的文件')
                    return false
                }
                if (file.size > maxSize) {
                    this.$message.error('单文件大小不能超过 2MB')
                    return false
                }
                return true
            },
            // 开始上传前验证(旧逻辑，仅对话框用)
            beforeUploadForm() {
                if (this.ruleForm.sysFileDescribe == '') {
                    alert("请先选择文件描述")
                    this.checkDialogVisible = false
                    return false
                }
                this.checkDialogVisible = false
            },
            // 上传成功
            successHandle(response, file, fileList) {
                this.uploadLoading = false;
                this.fileList = fileList
                this.successNum++
                if (response && response.code === 0) {
                    this.$message({
                        message: '上传成功！！',
                        type: 'success'
                    })
                    this.checkDialogVisible = false
                    this.ruleForm.sysFileType = ''
                    this.getDataList(this.venderInviteFid)
                } else {
                    this.$message.error(response.msg)
                }
            },
            beforeUploadForm1() {
                this.checkDialogVisible = true
                // var tempcheck = this.ruleForm.sysFileDescribe != '';
            },

            //修改描述
            handleUpdate(row) {
                if (row.sysFileId === undefined || row.sysFileId === null || row.sysFileId === '') {
                    this.$message({
                        message: '没有上传文件不能修改描述',
                        type: 'success',

                    })
                    return
                }
                this.updateVisible = true
                this.sysFileId = row.sysFileId
                this.dataForm.sysFileDescribe = row.sysFileDescribe
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            //删除
            deleteHandle(row) {
                // if (row.sysFileId === undefined || row.sysFileId === null || row.sysFileId === '') {
                //     this.$message({
                //         message: '没有上传文件不能删除',
                //         type: 'success',

                //     })
                //     return
                // }
                // if (this.applyStatus == 1 || this.applyStatus == 3) {
                //     this.$message({
                //         message: '已提交不能删除',
                //         type: 'success',
                //     })
                //     return
                // }
                var rfqFileIds = row ? [row.sysFileId] : this.dataListSelections.map(item => {
                    return item.sysFileId
                })
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log(rfqFileIds)
                    // this.$http({
                    //   url: this.$http.adornUrl('/rfqfile/trfqfile/delete'),
                    //   method: 'post',
                    //   data: this.$http.adornData(rfqFileIds, false)
                    // }).then(({
                    //     data
                    // }) => {
                    //   if (data && data.code === 0) {
                    //     this.$message({
                    //       message: '删除成功',
                    //       type: 'success',
                    //
                    //     })
                    //     this.ruleForm.sysFileType = ''
                    //     this.getDataList(this.venderInviteFid)
                    //   } else {
                    //     this.$message.error(data.msg)
                    //   }
                    // })
                    deleteFileById({
                    'fileId': row.id
                    }).then(data => {
                        if (data.code === '00') {
                            this.getDataList();
                            this.$message.success({
                                message: '删除成功！',
                                type: 'success',
                                duration: 1500,
                            });
                        }
                    }).catch(() => {

                    })
                })
            },
            //关系弹窗
            closeDialog() {
                this.updateVisible = false
                this.sysFileId = ''
                this.getDataList(this.ruleForm.venderInviteFid)
            },
            //保存
            saveRemark() {
                // var ID = this.sysFileId
                // this.$http({
                //   url: this.$http.adornUrl(`/rfqfile/trfqfile/update`),
                //   method: 'post',
                //   data: this.$http.adornData({
                //     'sysFileId': ID,
                //     'sysFileDescribe': this.dataForm.sysFileDescribe
                //   })
                // }).then(({
                //   data
                // }) => {
                //   if (data && data.code === 0) {
                //     this.$message({
                //       message: '修改成功',
                //       type: 'success',
                //       // duration: 1500,
                //       onClose: () => {
                //         this.updateVisible = false
                //         this.dataForm.sysFileDescribe = ''
                //         // this.getDataList(this.rfqFid, this.statusflag)
                //       }
                //     })
                //   } else {
                //     this.$message.error(data.msg)
                //   }
                // })
            },
            uploadConfig(row) {
                getUrl({
                    'fileId': row.id
                }).then(data => {
                    if (data && data.code === '00' && data.body) {
                        // location.href=data.body; 
                        this.download(data.body, row.originalName)
                    } else {
                        this.tableData = []
                    }
                })
            },
            //查询上传文件的信息
            getDataList() {
                getBasicInfoFiles({
                    'inviteId' : this.venderInviteFid
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body
                    } else {
                        // data.page.list[0].position == '法人'
                        // data.page.list[1].position == '商务经理'
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            getList() {
                listInvitedForSupplier().then(data => {
                    this.venderInviteFid = data.body.records[0].id
                })
            },

            getBlob(url, cb) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "blob";
              xhr.onload = function() {
                if (xhr.status === 200) {
                  cb(xhr.response);
                }
              };
              xhr.send();
            },
            saveAs(blob, filename) {
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
              } else {
                var link = document.createElement("a");
                var body = document.querySelector("body");

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                // fix Firefox
                link.style.display = "none";
                body.appendChild(link);

                link.click();
                body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
              }
            },
            download(url, filename) {
              const _this = this
              this.getBlob(url, function(blob) {
                _this.saveAs(blob, filename);
              });
            }
        }
    }
</script>
